import { Badge } from "@/components/ui/badge"

export default function PlannerModifyObjectiveStep() {
  return (
    <section className="flex flex-col gap-4">
      <header className="flex items-center gap-2">
        <h1 className="text-base font-bold">Modificar nota objetivo de la materia</h1>
      </header>
      <img
        className="w-full object-contain"
        src="https://storage.googleapis.com/educabot-aec-cdn-1/tuni/product-tour/planner-modify-objective.gif"
      />
      <p className="text-left text-sm text-muted-foreground">
        Definí la nota que querés alcanzar por cada materia: sobresalir, destacar o aprobar. Esto
        ajustará tu carga de estudio y te asignará objetivos personalizados para llegar a tu meta.
      </p>
      <Badge className="-mb-12 w-fit bg-primary-50 text-primary-500">
        <span className="font-semibold">Paso 3 de 8</span>
      </Badge>
    </section>
  )
}
